<div class="video-container" style="overflow:hidden;">
	<div class="videoViewerFocus" [ngClass]="{panelOn : panelOn, 'mobile-view': (isMobile && panelOn)}" style="width:100%; height:100%; margin-top:20px;">
		<video id="videoplayer"
			kvvideo 
			[src]="viewerURL" 
			[clipScope]="videoclip" 
			class="full-center" 
			style="max-height:100%;max-width:100%" 
			preload='none' 
			controls 
			autoplay>
		    <source type="video/mp4" />
		    <source type="video/ogg" />
		    {{LOCALIZATION.viewerVideoError}}
		    <img *ngIf="viewerOverviewURL"  [src]="viewerOverviewURL" />
		</video>
	</div>
	
	<!-- Chipping panel -->
	<div id='videoViewerPanel' class='viewerPanel' [ngClass]='{hide : !panelOn, "mobile-view": isMobile}'>
<!--             <div class="text-center viewer-panel-header"><h3 style='margin:10px'>{{LOCALIZATION.videClipping}}</h3></div> -->
<!--             <div class="" style="padding:5px 10px 5px 5px"> -->
<!--                 <slider floor="0" ceiling="{{videoclip.videoDuration}}" step="1" precision="10" ng-model-low="videoclip.begin" ng-model-high="videoclip.end"></slider> -->
<!--             </div> -->
<!--             <div class="text-center" style="padding:10px"> -->
<!--                 <span>{{videoclip.begin}}s to {{videoclip.end}}s</span> -->
<!--             </div> -->
<!--             <div class="text-right" style="padding:10px"><button class="btn btn-primary btn-sm submit-button submit-button-sm" ng-click="videoclip.performClip()">{{LOCALIZATION.download}}</button></div> -->
	</div>	
</div>